
export default class VibrationSignal {
    self = this;
    constructor(sampleSize, samplingFrequency, signal) {
        this.sampleSize = sampleSize;
        this.samplingFrequency = samplingFrequency;
        this.time = sampleSize / samplingFrequency;
        this.t = Array.from({ length: sampleSize }, (_, i) => i / samplingFrequency);
        this.f = Array.from({ length: parseInt(this.sampleSize / 2) + 1 }, (_, i) => i * (samplingFrequency / 2) / (parseInt(this.sampleSize / 2) + 1));
        this.frequencies = {};
        if (signal) {
            this.signal = signal;
            this.signalGiven = true;
        } else {
            this.signalGiven = false;
            this.signal = [...new Array(this.sampleSize)].map(() => 0.0);

        }
    }
    clear() {
        for (var frequency of Object.keys(this.frequencies)) {
            delete this.frequencies[frequency];
        }
    }
    getFrequencyDomain() {
        return this.f;
    }
    removeFrequency(frequency) {
        delete this.frequencies[frequency];
    }
    addFrequency(frequency, amplitude) {
        if (!this.signalGiven) {
            let signal = Array.from({ length: this.sampleSize }, (_, i) => {
                var sampleFreq = this.samplingFrequency / frequency;
                return amplitude * Math.sin((i) / (sampleFreq / (Math.PI * 2)));
            });
            this.frequencies[frequency] = signal;
        }
    }
}